import Vue from 'vue';
import grillshopModule from '../store/grillshop';

const grillshop = {
    getBasketTotalExclVat() {
        const basketSubtotalExclVat = this.getBasketSubTotalExclVat();
        const shippingTotal = Vue.$basket.getShippingTotal();
        const productsFeesTotal = Vue.$basket.getProductsFeesTotal();
        const totalDiscount = Vue.$basket.getTotalDiscount();

        const basketMaxVat = this.getBasketMaxVat();

        return basketSubtotalExclVat +
            this.calculateNetPrice((shippingTotal + productsFeesTotal - totalDiscount), basketMaxVat);
    },

    getBasketSubTotalExclVat() {
        let total = 0;
        const items = Vue.$basket.getBasketItems();
        Object.values(items).forEach(item => {
            total += this.getBasketItemTotalPriceExclVat(item) * item.quantity;
        });
        return total;
    },

    getBasketItemTotalPriceExclVat(item) {
        let vat = this.getBasketItemVat(item);
        let price = Vue.$basket.getPriceData(item, null).price;
        return this.calculateNetPrice(price, vat);
    },

    getBasketMaxVat() {
        let vat = [];
        const items = Vue.$basket.getBasketItems();
        Object.values(items).forEach(item => {
            vat.push((this.getBasketItemVat(item) > 0) ? this.getBasketItemVat(item) : 0);
        });
        return Math.max.apply(Math, vat);
    },

    getBasketItemVat(item) {
        return parseInt(Vue.$basket.getPriceData(item, null).VAT ? Vue.$basket.getPriceData(item, null).VAT : 0);
    },

    calculateNetPrice(price, vat) {
        return price * 100 / (100 + vat);
    },

};

export default {
    install: function(Vue) {
        if (!Vue.$store.state['Grillshop']) {
            Vue.$store.registerModule('Grillshop', grillshopModule);
        }

        Vue.$store.watch(Vue.$order.getDeliveryCountry, val => {
            Vue.$store.dispatch('Grillshop/queryShippingTypes', {
                country: val
            });
        });

        Vue.prototype.$grillshop = grillshop;
        Vue.$grillshop = grillshop;
    }
};
